import { BrandKey } from '@prismamedia/one-brandkey';
import { ArchiveKeyType } from '../../../../__generated__/queries-photo';

export type ONE_PHOTO_ARCHIVES =
  | ArchiveKeyType.CTM_WEB
  | ArchiveKeyType.IA_PRISMA_ARCHIVES
  | ArchiveKeyType.PECO_WEB
  | ArchiveKeyType.TRV_WEB_GRAPHIX;

export const LAST_CREATED_PHOTOS_TEXT = 'LES DERNIÈRES PHOTOS CRÉEES';
export const SEARCH_BAR_PLACEHOLDER = 'Rechercher des images One Photos';

export const ARCHIVES_FILTER_PREMIUM: ONE_PHOTO_ARCHIVES[] = [
  ArchiveKeyType.TRV_WEB_GRAPHIX,
  ArchiveKeyType.PECO_WEB,
  ArchiveKeyType.IA_PRISMA_ARCHIVES,
];

export const ARCHIVES_FILTER_DEFAULT: ONE_PHOTO_ARCHIVES[] = [
  ArchiveKeyType.TRV_WEB_GRAPHIX,
  ArchiveKeyType.IA_PRISMA_ARCHIVES,
];

export const ARCHIVES_FILTER_CTM: ONE_PHOTO_ARCHIVES[] = [
  ArchiveKeyType.TRV_WEB_GRAPHIX,
  ArchiveKeyType.IA_PRISMA_ARCHIVES,
  ArchiveKeyType.CTM_WEB,
];

export const ARCHIVES_LABEL = {
  [ArchiveKeyType.CTM_WEB]: 'CTM Web',
  [ArchiveKeyType.TRV_WEB_GRAPHIX]: 'Graphics Sources',
  [ArchiveKeyType.PECO_WEB]: 'Base gratuite PECO',
  [ArchiveKeyType.IA_PRISMA_ARCHIVES]: 'IA Prisma Archives',
};

export const BRANDS_PREMIUM_ACCESS_ARCHIVES = [
  BrandKey.BIN,
  BrandKey.CAP,
  BrandKey.CAM,
  BrandKey.GEO,
  BrandKey.NEO,
];

export const BRANDS_CTM_ACCESS_ARCHIVES = [BrandKey.CTM];
